module.exports = __webpack_public_path__ + "img/tab4.a46690fe.png";